(function() {
    'use strict';

    angular
        .module('uwAgenda.global')
        .directive('multiSelectRequiredValidation', MultiSelectRequiredValidationFn);

    /* multiple select required validation */
    MultiSelectRequiredValidationFn.$inject = [];
    
    function MultiSelectRequiredValidationFn() {
      
        var directive = {
            link: link,
            require: 'ngModel',
            restrict: 'A'
        };
        return directive;

        function link(scope, element, attrs, mCtrl) {

            // is at least one item selected ?
            function isOk(value) {                
                return angular.isArray(value) && value.length > 0;
            }

            // item is required
            mCtrl.$validators.required = function (value) {
                return isOk(value);
            };           
        }
    }

})();